import { useCallback, useSyncExternalStore } from 'react';

/** Viewports narrower than Tailwind's `md` breakpoint. */
export const PHONE_VIEWPORT_QUERY = '(max-width: 767px)';

/**
 * Evaluates a CSS media query and re-renders whenever it starts or stops
 * matching.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onStoreChange: () => void) => {
      const mediaQueryList = window.matchMedia(query);
      mediaQueryList.addEventListener('change', onStoreChange);
      return () => mediaQueryList.removeEventListener('change', onStoreChange);
    },
    [query],
  );

  const getSnapshot = useCallback(
    () => window.matchMedia(query).matches,
    [query],
  );

  return useSyncExternalStore(subscribe, getSnapshot);
}

export function useIsPhoneViewport(): boolean {
  return useMediaQuery(PHONE_VIEWPORT_QUERY);
}
